/**
 * Stellt Eine Funktion zum Finden von Diensten bereit.
 *
 * @class service_v3sServiceFinder
 * @memberOf v3sWbtPlayerApp:helper
 */
angular.module('v3sWbtPlayerApp').factory('v3sServiceFinder', ["$injector", function ($injector) {

    /**
     * Sucht Service.
     * @memberOf v3sWbtPlayerApp:helper.service_v3sServiceFinder
     * @param {string} serviceName - Service-Name
     * @param {string} type - Service-Type
     */
    function get(serviceName, serviceType) {
        var service = null;

        if (serviceType) {
            // quiz-wp -> QuizWp
            serviceType = serviceType.replace(/^([a-z])/, function (x) { return x[0].toUpperCase(); }).replace(/-([a-z])/g, function (x) { return x[1].toUpperCase(); });

            var serviceNameWithType = serviceName + serviceType;
            if ($injector.has(serviceNameWithType)) {
                service = $injector.get(serviceNameWithType);
            }
        }

        if (!service && $injector.has(serviceName)) {
            service = $injector.get(serviceName);
        }

        return service;
    }

    return {
        get: get
    }
}]);